export default __webpack_public_path__ + "static/media/BlackCurtain1.e7b08308.png";